import * as React from "react";
import { Spectacle } from "../types";
import { DOMAIN } from "../apiCalls";

interface Props {
  data: Spectacle;
}

const SpectacleInformations: React.FC<Props> = ({ data }) => {
  const formattedDate = new Date(data.Date).toLocaleDateString("pl-PL", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });
  const formattedHour = new Date(data.Date).toLocaleTimeString("pl-PL");

  const imgUrl = data.Icon ? `${DOMAIN}/upload/${data.Icon.substring(3)}` : "";
  return (
    <>
      <nav className="navbar minimal navbar-expand-lg">
        <a rel="dofollow" href="https://teatr.torun.pl/">
          <img src="/images/logo.svg" alt="Teatr Horzycy Logo" />
        </a>
      </nav>
      <div
        className="jumbotron jumbotron-fluid text-center page-header shop-header"
        style={{ background: `url(${imgUrl})` }}
      >
        <div className="overlay topdown-black"></div>
        <div className="container">
          <h1 className="h3">{data.DisplayName}</h1>
          <h2 className="h3">{data.TitleWeb}</h2>
          <p>{data.DescribeWeb}</p>
          <p className="subtitle h6">
            {formattedDate}, godzina {formattedHour}
          </p>

          <p className="subtitle h6">{data.Name}</p>

          <p className="subtitle h6">{data.Adress}</p>
        </div>
      </div>
    </>
  );
};

export default SpectacleInformations;
